module.exports = __webpack_public_path__ + "media/images/navbar-logo-c8833dc60622044c95fc425d9aabef62.webp";